import { usesEnforcedCommerce } from './onecStockAvailability';

const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const optional = (value, check) => value === null || value === undefined || check(value);
const text = value => typeof value === 'string';
const scalar = value => text(value) || (typeof value === 'number' && Number.isFinite(value));
const fields = (value, keys, check) => keys.every(key => optional(value[key], check));
const denseRecords = (value, check = () => true) => {
  if (!Array.isArray(value)) return false;
  for (let index = 0; index < value.length; index++) {
    if (!record(value[index]) || !check(value[index])) return false;
  }
  return true;
};
const ids = value => fields(value, ['id', 'sizeId', 'productId', 'colorId'], scalar);
const color = value => record(value) && ids(value) && fields(value, ['color_name', 'img', 'hex'], text);
const size = value => ids(value) && optional(value.size_name, text) && optional(value.childProduct_Size, record);
const parent = value => record(value) && ids(value) && optional(value.price, scalar) &&
  optional(value.product_url, text) && optional(value.childProducts, denseRecords);
const child = value => ids(value) && fields(value, ['code', 'product_url'], text) &&
  fields(value, ['sell_price', 'sell_value'], scalar) && optional(value.color, color) &&
  optional(value.product, parent) && optional(value.child_product_size_field, entries => denseRecords(entries, size)) &&
  optional(value.child_product_size, entries => denseRecords(entries, size));

function renderableRow(row) {
  if (!child(row) || !parent(row.product)) return false;
  const siblings = row.product.childProducts;
  if (siblings == null) return true;
  if (!denseRecords(siblings, sibling => child(sibling) && (!sibling.is_active || color(sibling.color)))) return false;
  // Structural guard for BOTH legacy offer rendering and the real Catalog
  // observer. This does not evaluate availability, identity evidence or stock.
  const selected = siblings.find(sibling => sibling.id === row.id);
  if (!selected || color(selected.color)) return true;
  const sizes = selected.child_product_size_field || [];
  const defaultSize = sizes.find(entry => usesEnforcedCommerce(selected) ? entry.isActive === true : entry.isActive !== false);
  const reachable = sizes.filter(entry => entry.isActive).map(entry => entry.size_name);
  if (defaultSize) reachable.push(defaultSize.size_name);
  return !reachable.some(name => name && (selected.child_product_size || []).some(pivot => pivot.size_name === name));
}

const count = value => Number.isSafeInteger(value) && value >= 0;
const facet = (value, names) => ids(value) && fields(value, names, text) &&
  optional(value.checked, checked => typeof checked === 'boolean');
function renderableFacets(data) {
  if (data.hide === true) return true;
  return denseRecords(data.colors, value => facet(value, ['color_name', 'img', 'hex'])) &&
    denseRecords(data.sizes, value => facet(value, ['size_name'])) &&
    denseRecords(data.trends, value => facet(value, ['name'])) &&
    Number.isFinite(data.price_min) && Number.isFinite(data.price_max) &&
    data.price_min >= 0 && data.price_max >= data.price_min;
}

/** A local transport/render-safety result. Public DTO values remain untouched. */
export function readCatalogCollectionResponse(kind, response) {
  const failure = {ok: false, status: [400, 404, 503].includes(response?.status) ? response.status : 503};
  if (!Number.isInteger(response?.status) || response.status < 200 || response.status >= 300 ||
      !record(response.data) || response.data.error) return failure;
  const data = response.data;
  const valid = kind === 'rows' ? count(data.count) && denseRecords(data.rows, renderableRow)
    : kind === 'count' ? count(data.count)
    : kind === 'facets' ? renderableFacets(data) : false;
  return valid ? {ok: true, data} : failure;
}
